import { InputNumber, Slider } from "antd";
import React from "react";
import { Button, Modal } from "react-bootstrap";

const FilterModal = ({
  showModal,
  filterOption,
  setFilterOption,
  availableGenders,
  gender,
  category,
  subCategory,
  subSubCategory,
  displaySubCatMap,
  range,
  size,
  alphabeticSizes,
  availableSizes,
  numericSizes,
  sortBy,
  sortOptions,
  setSortBy,
  handleGenderChange,
  handleCategoryChange,
  handleSubCategoryChange,
  handleRangeChange,
  handleMinInputChange,
  handleMaxInputChange,
  handleSizeChange,
  handleClose,
  resetBrandFilter,
  handleApplyFilter,
  handleBrandChange,
  brands,
  selectedBrands,
  type,
}) => {
  const FilterOption = (option, text) => {
    return (
      <div
        onClick={() => setFilterOption(option)}
        style={{
          cursor: "pointer",
          outline: "1px solid #C3C3C3",
          backgroundColor: filterOption === option ? "#005FDA" : "white",
        }}
        className={`py-3 ps-4 h6 mb-0 fw-light ${
          filterOption === option ? "text-white" : ""
        }`}
      >
        {text}
      </div>
    );
  };
  const selectedOptionDivHeading = (text) => {
    return (
      <div
        style={{
          fontFamily: "Inter",
          fontWeight: "500",
          fontSize: "18px",
          color: "black",
          marginBottom: "12px",
        }}
      >
        {text}
      </div>
    );
  };
  return (
    <Modal
      className="brandProductsModal"
      show={showModal}
      centered
      onHide={handleClose}
    >
      <Modal.Body className="p-0">
        <div className="d-flex flex-column">
          <div className="d-flex w-100 justify-content-between align-items-center px-4 py-3">
            <div className="h3 mb-0">Filter</div>
            <svg
              style={{ cursor: "pointer", height: "2.2rem" }}
              onClick={() => {
                handleClose();
              }}
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d_1381_695)">
                <rect
                  x="4"
                  y="4"
                  width="30"
                  height="30"
                  rx="15"
                  fill="white"
                  shape-rendering="crispEdges"
                />
                <rect
                  x="4.5"
                  y="4.5"
                  width="29"
                  height="29"
                  rx="14.5"
                  stroke="#FF3B30"
                  shape-rendering="crispEdges"
                />
                <path
                  d="M25 13L13 25M13 13L25 25"
                  stroke="#FF3B30"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d_1381_695"
                  x="0"
                  y="0"
                  width="40"
                  height="40"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dx="1" dy="1" />
                  <feGaussianBlur stdDeviation="2.5" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.116536 0 0 0 0 0.116536 0 0 0 0 0.116536 0 0 0 0.14 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_1381_695"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_1381_695"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </div>
          {/* Modal Body */}
          <div className="d-flex w-100">
            <div style={{ width: "30%" }} className="d-flex flex-column">
              {type === "AllProducts" ? (
                <>{FilterOption("brands", "Brands")}</>
              ) : (
                <>
                  {FilterOption("gender", "Gender")}
                  {FilterOption("category", "Category")}
                  {FilterOption("subCategory", "Sub-Category")}
                </>
              )}

              {FilterOption("price", "Price")}
              {FilterOption("size", "Size")}
              {FilterOption("sort", "Sort By")}
            </div>
            <div
              className="p-3"
              style={{
                outline: "1px solid #C3C3C3",
                width: "70%",
                height: "19rem",
                overflowY: "auto",
              }}
            >
              {filterOption === "brands" && (
                <>
                  {selectedOptionDivHeading("Brands")}
                  <div
                    className="row gap-3 mx-0 p-1 pe-2"
                    // style={{ maxHeight: "20rem", overflowY: "auto" }}
                  >
                    {brands?.map((brand) => (
                      <div
                        key={brand.id}
                        style={{
                          whiteSpace: "nowrap",
                          cursor: "pointer",
                          outline: "1px solid #C3C3C3",
                        }}
                        className={`d-flex align-items-center justify-content-center col py-2 rounded-3 ${selectedBrands.includes(
                          brand.id
                        ) && "selected"}`}
                        onClick={() => handleBrandChange(brand.id)}
                      >
                        {brand.displayName}
                      </div>
                    ))}
                  </div>
                </>
              )}
              {filterOption === "gender" && (
                <>
                  {selectedOptionDivHeading("Gender")}
                  <div className="row gap-3 mx-0">
                    <div
                      style={{
                        whiteSpace: "nowrap",
                        cursor: availableGenders.includes("Men")
                          ? "pointer"
                          : "default",
                        outline: "1px solid #C3C3C3",
                        opacity: availableGenders.includes("Men") ? 1 : 0.5,
                      }}
                      className={`d-flex align-items-center justify-content-center col py-2 rounded-3 ${gender.includes(
                        "Men"
                      ) && "selected"}`}
                      onClick={() => {
                        if (availableGenders.includes("Men"))
                          handleGenderChange("Men");
                      }}
                    >
                      Men
                    </div>
                    <div
                      style={{
                        whiteSpace: "nowrap",
                        cursor: availableGenders.includes("Women")
                          ? "pointer"
                          : "default",
                        outline: "1px solid #C3C3C3",
                        opacity: availableGenders.includes("Women") ? 1 : 0.5,
                      }}
                      className={`d-flex align-items-center justify-content-center col py-2 rounded-3 ${gender.includes(
                        "Women"
                      ) && "selected"}`}
                      onClick={() => {
                        if (availableGenders.includes("Women"))
                          handleGenderChange("Women");
                      }}
                    >
                      Women
                    </div>
                  </div>
                </>
              )}
              {filterOption === "category" && (
                <>
                  {selectedOptionDivHeading("Category")}
                  <div className="row gap-3 mx-0">
                    <div
                      style={{
                        whiteSpace: "nowrap",
                        cursor: "pointer",
                        outline: "1px solid #C3C3C3",
                      }}
                      className={`d-flex align-items-center justify-content-center col py-2 rounded-3 ${category.includes(
                        "Ready to Wear"
                      ) && "selected"}`}
                      onClick={() => handleCategoryChange("Ready to Wear")}
                    >
                      Ready to Wear
                    </div>
                    <div
                      style={{
                        whiteSpace: "nowrap",
                        cursor: "pointer",
                        outline: "1px solid #C3C3C3",
                      }}
                      className={`d-flex align-items-center justify-content-center col py-2 rounded-3 ${category.includes(
                        "Unstitched"
                      ) && "selected"}`}
                      onClick={() => handleCategoryChange("Unstitched")}
                    >
                      Unstitched
                    </div>
                    <div
                      style={{
                        whiteSpace: "nowrap",
                        cursor: "pointer",
                        outline: "1px solid #C3C3C3",
                      }}
                      className={`d-flex align-items-center justify-content-center col py-2 rounded-3 ${category.includes(
                        "Western Wear"
                      ) && "selected"}`}
                      onClick={() => handleCategoryChange("Western Wear")}
                    >
                      Western Wear
                    </div>
                  </div>
                </>
              )}
              {filterOption === "subCategory" && (
                <>
                  {selectedOptionDivHeading("Sub-Category")}
                  <div className="row gap-3 mx-0">
                    {subSubCategory?.map((subCat) => (
                      <div
                        key={subCat}
                        style={{
                          whiteSpace: "nowrap",
                          cursor: "pointer",
                          outline: "1px solid #C3C3C3",
                        }}
                        className={`d-flex align-items-center justify-content-center col py-2 rounded-3 ${subCategory.includes(
                          subCat
                        ) && "selected"}`}
                        onClick={() => handleSubCategoryChange(subCat)}
                      >
                        {displaySubCatMap[subCat]}
                      </div>
                    ))}
                  </div>
                </>
              )}
              {filterOption === "price" && (
                <div className="flex-1 justify-content-center">
                  {selectedOptionDivHeading("Price")}
                  <div className="rounded-3 mb-3">
                    <Slider
                      range
                      value={range}
                      onChange={handleRangeChange}
                      min={0}
                      max={90000}
                      step={500}
                      tipFormatter={(value) => `${value}`}
                    />
                  </div>

                  <div className="row mx-0 gap-2 w-100">
                    <div className="col">
                      <label>Min</label>
                      <InputNumber
                        className="w-100"
                        min={0}
                        max={90000}
                        value={range[0]}
                        onChange={handleMinInputChange}
                        placeholder={range[0]}
                      />
                    </div>
                    <div className="col">
                      <label>Max</label>
                      <InputNumber
                        className="w-100"
                        min={0}
                        max={90000}
                        value={range[1]}
                        onChange={handleMaxInputChange}
                        placeholder={range[1]}
                      />
                    </div>
                  </div>
                </div>
              )}
              {filterOption === "size" && (
                <>
                  {selectedOptionDivHeading("Size")}
                  <div className="row gap-3 mx-0">
                    {alphabeticSizes &&
                      alphabeticSizes?.map((s) => (
                        <div
                          key={s}
                          style={{
                            whiteSpace: "nowrap",
                            cursor: availableSizes.includes(s)
                              ? "pointer"
                              : "default",
                            outline: "1px solid #C3C3C3",
                            opacity: availableSizes.includes(s) ? 1 : 0.5,
                          }}
                          className={`d-flex align-items-center justify-content-center col py-2 rounded-3 ${size.includes(
                            s
                          ) && "selected"}`}
                          onClick={() => {
                            if (availableSizes.includes(s)) handleSizeChange(s);
                          }}
                        >
                          {s}
                        </div>
                      ))}
                    {numericSizes &&
                      numericSizes?.map((s) => (
                        <div
                          key={s}
                          style={{
                            whiteSpace: "nowrap",
                            cursor: numericSizes.includes(s)
                              ? "pointer"
                              : "default",
                            outline: "1px solid #C3C3C3",
                          }}
                          className={`d-flex align-items-center justify-content-center col py-2 rounded-3 ${size.includes(
                            s
                          ) && "selected"}`}
                          onClick={() => {
                            if (numericSizes.includes(s)) handleSizeChange(s);
                          }}
                        >
                          {s}
                        </div>
                      ))}
                  </div>
                </>
              )}
              {filterOption === "sort" && (
                <>
                  {selectedOptionDivHeading("Sort By")}
                  <div className="row gap-3 mx-0">
                    {sortOptions &&
                      sortOptions?.map((option) => (
                        <div
                          key={option.value}
                          style={{
                            whiteSpace: "nowrap",
                            cursor: "pointer",
                            outline: "1px solid #C3C3C3",
                          }}
                          className={`d-flex align-items-center justify-content-center col py-2 rounded-3 ${sortBy ===
                            option.value && "selected"}`}
                          onClick={() => {
                            setSortBy(option.value);
                          }}
                        >
                          {option.name}
                        </div>
                      ))}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="d-flex w-100 py-2">
          <div style={{ width: "30%" }} className="ps-4 pe-2">
            <Button
              className="rounded-3 w-100"
              variant="outline-secondary"
              onClick={() => {
                //Reset Modal function
                resetBrandFilter();
              }}
            >
              Reset
            </Button>
          </div>
          <div style={{ width: "70%" }} className="pe-4">
            <Button
              className="rounded-3 w-100"
              variant="primary"
              onClick={async () => {
                handleApplyFilter();
                handleClose();
              }}
            >
              Apply
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default FilterModal;
